import React from "react";
import {Box, makeStyles} from "@material-ui/core";
import {CardBase} from "../../organisms";
import Zoom from "react-medium-image-zoom";
import 'react-medium-image-zoom/dist/styles.css'

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
        '&:last-child': {
            padding: theme.spacing(1),
        }
    },
    
}));


function Video(props) {
    const {width, height, src, hasZoom} = props;
    const videoRef = React.useRef(null);
    const classes = useStyles();
    
    React.useEffect(() => {
        if (videoRef.current) {
            videoRef.current.muted = true;
            videoRef.current.play();
        }
    }, [videoRef.current])
    
    const video = (
       <Box width={'100%'} display={'flex'} justifyContent={'center'}>
           <Box width={width} height={height}>
               <CardBase withShadow={true} liftUp={true}  cardContentProps={{
                   classes: {
                       root: classes.root
                   }
               }}>
                   <video muted autoPlay loop={true} playsInline=""
                          ref={videoRef}
                          height="auto"
                          width={'100%'}
                          style={{display: 'block'}}>
                       <source src={src}
                               type="video/mp4"/>
                   </video>
               </CardBase>
           </Box>
       </Box>)
    
    return hasZoom ? <Zoom>{video}</Zoom> : video;
}

export default Video
